<script>
import SensorIcon from '@mobile/components/Icons/SensorIcon.vue';
import ItemCard from '@mobile/components/ItemCard.vue';
import { now } from '@/util/UnixTimestamps';
import { ISSUE_STATUS, ISSUE_PRIORITY } from '@/constants';

export default {
    name: 'IssueCard',

    components: { SensorIcon, ItemCard },

    props: {
        title: {
            type: String,
            required: true,
        },
        payload: {
            type: Object,
            required: false,
            default: () => null,
        },
        status: {
            type: Number,
            required: true,
        },
        priority: {
            type: Number,
            required: true,
        },
        dueAt: {
            type: Number,
            required: false,
            default: () => false,
        },
        resolvedAt: {
            type: Number,
            required: false,
            default: () => null,
        },
        resolvedBy: {
            type: Object,
            required: false,
            default: () => null,
        },
        assignees: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        issue() {
            return {
                title: this.title,
                payload: this.payload,
                status: this.status,
                priority: this.priority,
                dueAt: this.dueAt,
            };
        },

        hasSensor() {
            return this.payload && this.payload.sensor;
        },

        formattedStatus() {
            return {
                [ISSUE_STATUS.OPEN]: this.$t('ToDo'),
                [ISSUE_STATUS.IN_PROGRESS]: this.$t('Started'),
                [ISSUE_STATUS.SOLVED]: this.$t('Done'),
                [ISSUE_STATUS.CANT_DO]: this.$t('Can\'t do'),
            }[this.status || ISSUE_STATUS.OPEN];
        },

        formattedPriority() {
            return {
                [ISSUE_PRIORITY.MEDIUM]: {
                    text: this.$t('Normal'),
                    status: 'state-medium',
                },
                [ISSUE_PRIORITY.HIGH]: { text: this.$t('High'), status: 'state-bad' },
            }[this.priority || ISSUE_PRIORITY.LOW];
        },

        due() {
            if (this.status === ISSUE_STATUS.SOLVED) {
                return {
                    title: this.$t('Solved'),
                    description: this.resolvedAt ? this.$t('on {resolvedAt}', { resolvedAt: this.$du(this.resolvedAt, 'shortDateTime') }) : '',
                    state: 'state-good',
                };
            }
            if (!this.dueAt) {
                return {
                    title: this.$t('No deadline'),
                    description: false,
                    state: 'state-primary',
                };
            }

            const isOverdue = this.dueAt < now();
            const dueAt = this.$du(this.dueAt, 'shortDateTime');

            if (isOverdue) {
                return {
                    title: this.$t('Overdue'),
                    description: this.$t('since {dueAt}', { dueAt }),
                    state: 'state-bad',
                };
            }

            return {
                title: this.$t('Due'),
                description: this.$t('at {dueAt}', { dueAt }),
                state: 'state-medium',
            };
        },
    },
};
</script>

<template>
    <ItemCard :title="title">
        <template v-slot:badges>
            <SensorIcon v-if="hasSensor" class="mr-2" />
            <div class="badge" :class="formattedPriority.status">{{ formattedPriority.text }}</div>
        </template>
        <div class="badge" :class="due.state">{{ due.title }}</div>
        <p v-if="due.description" class="badge-explanation">{{ due.description }}</p>

        <p v-if="assignees.length > 0" class="text-90 mt-2">
            {{ assignees.join(', ') }}
        </p>
    </ItemCard>
</template>
